import { ActionTree } from 'vuex';
import { StateInterface } from '@/interfaces/projects';
import { feedbackDetails } from '@/interfaces/feedback';


const actions: ActionTree<feedbackDetails, StateInterface> = {
    setEnvios( state, envios) {
        state.commit('setEnvios', envios);
    },
    setFicheros(state, ficheros) {
        state.commit('setFicheros', ficheros);
    },
    setId(state, id) {
        state.commit('setId', id);
    },
    setNombre(state, nombre) {
        state.commit('setNombre', nombre);
    },

    resetFeedbackDetails( state ) {
        state.commit('setEnvios', 0);
        state.commit('setFicheros', 0);
        state.commit('setId', 0);
        state.commit('setNombre', '');
    }
}



export default actions;